import useScript from '@/hooks/useScript';

export const useAttentiveScript = (): boolean | undefined => {
  return useScript('https://cdn.attn.tv/outdoorsy/dtag.js');
};
